import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import FadeIn from "@/components/FadeIn";
import SeoHead from "@/components/SeoHead";
import { ARTICLES } from "@/data/articles";

export default function Inzichten() {
  return (
    <div data-testid="page-inzichten" className="pt-[96px]">
      <SeoHead
        title="Inzichten over AI, data en digitale regie | SovEU"
        description="Praktische inzichten over algoritmeregisters, AI governance, datalekken, digitale afhankelijkheid, CLOUD Act, AVG en digitale regie voor publieke en semipublieke organisaties."
        path="/inzichten"
      />

      <section className="section bg-white">
        <div className="container-soveu max-w-3xl">
          <FadeIn>
            <div className="eyebrow mb-4">Inzichten</div>
            <h1 className="h1-display mb-6">Inzichten</h1>
            <p className="body-lg text-[#334155] leading-relaxed">
              Praktische inzichten over AI governance, algoritmen, datagovernance, cloudafhankelijkheid, datalekken en digitale regie voor gemeenten, onderwijsinstellingen, woningcorporaties en andere publieke en semipublieke organisaties.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="bg-white pb-20">
        <div className="container-soveu max-w-3xl">
          <div className="space-y-5">
            {ARTICLES.map((a, i) => (
              <FadeIn key={a.slug} delay={i * 80}>
                <Link
                  to={a.to}
                  className="block soveu-card p-7 hover:shadow-md transition-shadow"
                  data-testid={`inzicht-card-${a.slug}`}
                >
                  <div className="flex items-start justify-between gap-5">
                    <div className="flex-1">
                      <div className="eyebrow text-[12px] mb-2">{a.category}</div>
                      <h2 className="text-[22px] md:text-[24px] font-semibold mb-3" style={{ color: "#1E3A5F" }}>
                        {a.title}
                      </h2>
                      <p className="text-[#334155] leading-relaxed text-[15px] mb-4">
                        {a.summary}
                      </p>
                      <div className="flex flex-wrap items-center gap-4 text-[13px] text-[#6B7280]">
                        <span className="inline-flex items-center gap-1.5">
                          <Calendar size={13} />
                          Laatst bijgewerkt: {a.lastUpdated}
                        </span>
                        <span
                          className="inline-flex items-center gap-1 font-medium"
                          style={{ color: "#2D6F8F" }}
                        >
                          Lees artikel
                          <ArrowRight size={14} />
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
